import ADMIN_PERMISSIONS from '@/constants/authorization/admin-permissions'

export default [
  {
    header: 'navigation.user-management',
  },
  {
    title: 'navigation.accounts',
    route: 'super:accounts',
    adminPermissions: [ADMIN_PERMISSIONS.ACCOUNTS],
    icon: 'AlignJustifyIcon',
  },
  {
    title: 'navigation.admin-users',
    route: 'super:users',
    adminPermissions: [ADMIN_PERMISSIONS.SUPER_ADMIN],
    icon: 'UsersIcon',
  },
  {
    title: 'navigation.customers',
    route: 'super:customers',
    adminPermissions: [ADMIN_PERMISSIONS.ACCOUNTS],
    icon: 'ListIcon',
  },
  {
    title: 'link-tree.title',
    route: 'super:link-tree',
    adminPermissions: [ADMIN_PERMISSIONS.ACCOUNTS],
    icon: 'LinkIcon',
  },
  {
    title: 'navigation.landing-pages',
    route: 'super:landing-pages',
    adminPermissions: [ADMIN_PERMISSIONS.SUPER_ADMIN],
    icon: 'LayoutIcon',
  },
  {
    title: 'urls.title',
    route: 'super:urls',
    adminPermissions: [ADMIN_PERMISSIONS.URL_REDIRECT],
    icon: 'LinkIcon',
  },
  {
    title: 'navigation.register-requests',
    route: 'super:register-requests',
    adminPermissions: [ADMIN_PERMISSIONS.ACCOUNTS],
    icon: 'ListIcon',
  },
  {
    title: 'cloud-kitchen.accounts-title',
    route: 'super:cloud-kitchen',
    adminPermissions: [ADMIN_PERMISSIONS.ACCOUNTS],
    icon: 'ListIcon',
  },
]
